import * as S from "../Cadastro/styles";

import FormLogin from '../../Components/FormLogin';
import { Header } from "../../Components/Layout/header";
import { Footer } from "../../Components/Layout/footer";

function App() {
    return (
        <S.Container className="">
            <FormLogin />
        </S.Container>
    );
}

export default App;